export const INACTIVATION_REASONS = [
  // Absenteísmo / ausência
  {
    movementType: 'ABSENCE',
    movementTypeLabelPtBr: 'Absenteísmo / ausência',
    reasonCode: 'UNJUSTIFIED_ABSENCE',
    labelPtBr: 'Falta injustificada',
    impactsAbsenteeism: true,
    impactsTurnover: false,
  },
  {
    movementType: 'ABSENCE',
    movementTypeLabelPtBr: 'Absenteísmo / ausência',
    reasonCode: 'JUSTIFIED_ABSENCE',
    labelPtBr: 'Falta justificada',
    impactsAbsenteeism: true,
    impactsTurnover: false,
  },
  {
    movementType: 'ABSENCE',
    movementTypeLabelPtBr: 'Absenteísmo / ausência',
    reasonCode: 'MEDICAL_CERTIFICATE',
    labelPtBr: 'Atestado médico',
    impactsAbsenteeism: true,
    impactsTurnover: false,
  },
  {
    movementType: 'ABSENCE',
    movementTypeLabelPtBr: 'Absenteísmo / ausência',
    reasonCode: 'TEMPORARY_ABSENCE',
    labelPtBr: 'Ausência temporária',
    impactsAbsenteeism: true,
    impactsTurnover: false,
  },

  // Licenças / afastamentos
  {
    movementType: 'LEAVE',
    movementTypeLabelPtBr: 'Licenças / afastamentos',
    reasonCode: 'MEDICAL_LEAVE',
    labelPtBr: 'Licença médica',
    impactsAbsenteeism: true,
    impactsTurnover: false,
  },
  {
    movementType: 'LEAVE',
    movementTypeLabelPtBr: 'Licenças / afastamentos',
    reasonCode: 'SOCIAL_SECURITY_LEAVE',
    labelPtBr: 'Afastamento previdenciário / INSS',
    impactsAbsenteeism: true,
    impactsTurnover: false,
  },
  {
    movementType: 'LEAVE',
    movementTypeLabelPtBr: 'Licenças / afastamentos',
    reasonCode: 'MATERNITY_LEAVE',
    labelPtBr: 'Licença maternidade',
    impactsAbsenteeism: true,
    impactsTurnover: false,
  },
  {
    movementType: 'LEAVE',
    movementTypeLabelPtBr: 'Licenças / afastamentos',
    reasonCode: 'PATERNITY_LEAVE',
    labelPtBr: 'Licença paternidade',
    impactsAbsenteeism: true,
    impactsTurnover: false,
  },
  {
    movementType: 'LEAVE',
    movementTypeLabelPtBr: 'Licenças / afastamentos',
    reasonCode: 'PARENTAL_LEAVE',
    labelPtBr: 'Licença parental',
    impactsAbsenteeism: true,
    impactsTurnover: false,
  },
  {
    movementType: 'LEAVE',
    movementTypeLabelPtBr: 'Licenças / afastamentos',
    reasonCode: 'UNPAID_LEAVE',
    labelPtBr: 'Licença não remunerada',
    impactsAbsenteeism: true,
    impactsTurnover: false,
  },

  // Férias / recesso
  {
    movementType: 'VACATION',
    movementTypeLabelPtBr: 'Férias / recesso',
    reasonCode: 'VACATION',
    labelPtBr: 'Férias',
    impactsAbsenteeism: false,
    impactsTurnover: false,
  },
  {
    movementType: 'VACATION',
    movementTypeLabelPtBr: 'Férias / recesso',
    reasonCode: 'COLLECTIVE_VACATION',
    labelPtBr: 'Férias coletivas',
    impactsAbsenteeism: false,
    impactsTurnover: false,
  },
  {
    movementType: 'VACATION',
    movementTypeLabelPtBr: 'Férias / recesso',
    reasonCode: 'COMPANY_RECESS',
    labelPtBr: 'Recesso',
    impactsAbsenteeism: false,
    impactsTurnover: false,
  },

  // Desligamento / rotatividade
  {
    movementType: 'TERMINATION',
    movementTypeLabelPtBr: 'Desligamento / rotatividade',
    reasonCode: 'VOLUNTARY_TERMINATION',
    labelPtBr: 'Desligamento voluntário',
    impactsAbsenteeism: false,
    impactsTurnover: true,
    turnoverType: 'VOLUNTARY',
  },
  {
    movementType: 'TERMINATION',
    movementTypeLabelPtBr: 'Desligamento / rotatividade',
    reasonCode: 'RESIGNATION',
    labelPtBr: 'Pedido de demissão',
    impactsAbsenteeism: false,
    impactsTurnover: true,
    turnoverType: 'VOLUNTARY',
  },
  {
    movementType: 'TERMINATION',
    movementTypeLabelPtBr: 'Desligamento / rotatividade',
    reasonCode: 'INVOLUNTARY_TERMINATION',
    labelPtBr: 'Desligamento involuntário',
    impactsAbsenteeism: false,
    impactsTurnover: true,
    turnoverType: 'INVOLUNTARY',
  },
  {
    movementType: 'TERMINATION',
    movementTypeLabelPtBr: 'Desligamento / rotatividade',
    reasonCode: 'TERMINATION_WITHOUT_CAUSE',
    labelPtBr: 'Demissão sem justa causa',
    impactsAbsenteeism: false,
    impactsTurnover: true,
    turnoverType: 'INVOLUNTARY',
  },
  {
    movementType: 'TERMINATION',
    movementTypeLabelPtBr: 'Desligamento / rotatividade',
    reasonCode: 'TERMINATION_WITH_CAUSE',
    labelPtBr: 'Demissão com justa causa',
    impactsAbsenteeism: false,
    impactsTurnover: true,
    turnoverType: 'INVOLUNTARY',
  },
  {
    movementType: 'TERMINATION',
    movementTypeLabelPtBr: 'Desligamento / rotatividade',
    reasonCode: 'MUTUAL_AGREEMENT_TERMINATION',
    labelPtBr: 'Desligamento por acordo',
    impactsAbsenteeism: false,
    impactsTurnover: true,
    turnoverType: 'MUTUAL_AGREEMENT',
  },
  {
    movementType: 'TERMINATION',
    movementTypeLabelPtBr: 'Desligamento / rotatividade',
    reasonCode: 'END_OF_CONTRACT',
    labelPtBr: 'Término de contrato',
    impactsAbsenteeism: false,
    impactsTurnover: true,
    turnoverType: 'CONTRACT_END',
  },
  {
    movementType: 'TERMINATION',
    movementTypeLabelPtBr: 'Desligamento / rotatividade',
    reasonCode: 'END_OF_PROBATION_PERIOD',
    labelPtBr: 'Término do período de experiência',
    impactsAbsenteeism: false,
    impactsTurnover: true,
    turnoverType: 'CONTRACT_END',
  },
  {
    movementType: 'TERMINATION',
    movementTypeLabelPtBr: 'Desligamento / rotatividade',
    reasonCode: 'RETIREMENT',
    labelPtBr: 'Aposentadoria',
    impactsAbsenteeism: false,
    impactsTurnover: true,
    turnoverType: 'NEUTRAL_OR_OTHER',
  },
  {
    movementType: 'TERMINATION',
    movementTypeLabelPtBr: 'Desligamento / rotatividade',
    reasonCode: 'DEATH',
    labelPtBr: 'Falecimento',
    impactsAbsenteeism: false,
    impactsTurnover: true,
    turnoverType: 'NEUTRAL_OR_OTHER',
  },
  {
    movementType: 'TERMINATION',
    movementTypeLabelPtBr: 'Desligamento / rotatividade',
    reasonCode: 'LAYOFF',
    labelPtBr: 'Redução de quadro',
    impactsAbsenteeism: false,
    impactsTurnover: true,
    turnoverType: 'INVOLUNTARY',
  },

  // Administrativo / cadastro
  {
    movementType: 'ADMINISTRATIVE',
    movementTypeLabelPtBr: 'Administrativo / cadastro',
    reasonCode: 'DUPLICATE_RECORD',
    labelPtBr: 'Cadastro duplicado',
    impactsAbsenteeism: false,
    impactsTurnover: false,
  },

  // Restrição de acesso / operação
  {
    movementType: 'ACCESS_RESTRICTION',
    movementTypeLabelPtBr: 'Restrição de acesso / operação',
    reasonCode: 'NO_WORK_DEVICE',
    labelPtBr: 'Sem equipamento de trabalho',
    impactsAbsenteeism: false,
    impactsTurnover: false,
  },
  {
    movementType: 'ACCESS_RESTRICTION',
    movementTypeLabelPtBr: 'Restrição de acesso / operação',
    reasonCode: 'NO_CORPORATE_EMAIL_OR_PHONE',
    labelPtBr: 'Sem e-mail ou telefone corporativo',
    impactsAbsenteeism: false,
    impactsTurnover: false,
  },
  {
    movementType: 'ACCESS_RESTRICTION',
    movementTypeLabelPtBr: 'Restrição de acesso / operação',
    reasonCode: 'ACCESS_TEMPORARILY_BLOCKED',
    labelPtBr: 'Acesso temporariamente bloqueado',
    impactsAbsenteeism: false,
    impactsTurnover: false,
  },

  // Outro
  {
    movementType: 'CUSTOM',
    movementTypeLabelPtBr: 'Outro',
    reasonCode: 'CUSTOM',
    labelPtBr: 'Outro motivo',
    impactsAbsenteeism: false,
    impactsTurnover: false,
    requiresCustomText: true,
  },
] as const;

export type InactivationReason = (typeof INACTIVATION_REASONS)[number];
export type InactivationReasonCode = InactivationReason['reasonCode'];
